module.exports = __webpack_public_path__ + "assets/img/hotSellBan.f0f48683.png";